import { useState, useEffect } from 'react';
import { throttle } from 'lodash';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handler = () => {
      setIsMobile(window.innerWidth < 685);
    };
    const throttled = throttle(handler, 300);
    window.addEventListener('resize', throttled);
    handler();

    return () => window.removeEventListener('resize', throttled);
  }, []);

  return { isMobile, setIsMobile };
};
